import styled from 'styled-components';

import colors from '@app/constants/colors';

const ErrorMessage = styled.p`
    font-size: 22px;
    color: ${colors.ERROR_COLOR};
    margin: 20px 0;
    text-align: center;
    text-transform: capitalize;
`;

export default ErrorMessage;
